import Link from "next/link";
import ServiceOfferBanner from "@/components/ServiceOfferBanner/ServiceOfferBanner";
import UserSimpleCard from "@/components/UserSimpleCard/UserSimpleCard";
import { FaLightbulb } from "react-icons/fa";
import { User } from "@/types/types";
import { servicesSlugTranslations } from "@/lib/pagesTranslations";
import { normalizeCategorySlug } from "@/lib/seo";

interface ServicesSlugPageProps {
  slug: string;
  title: string;
  users: User[];
  locale: "pt" | "en";
}

export default function ServicesSlugPage({
  slug,
  title,
  users,
  locale,
}: ServicesSlugPageProps) {
  const hasUsers = users && users.length > 0;
  const t = servicesSlugTranslations[locale] ?? servicesSlugTranslations["pt"];

  return (
    <div className="max-w-7xl mx-auto px-4 pb-8">
      <h1 className="text-2xl md:text-3xl text-[#1B475D] font-bold mb-10 capitalize">
        {title}
      </h1>

      {hasUsers ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {users.map((user) => (
            <Link key={user.id} href={`/${locale}/services/${normalizeCategorySlug(user.service.category)}/${user.id}`}>
              <div className="flex flex-col items-center justify-center">
                <UserSimpleCard
                  id={user.id}
                  isSupporter={user.isSupporter}
                  name={user.fullName}
                  avatarUrl={user.avatarUrl}
                  role={user.service.title}
                  location={`${user.location.city}${user.location.region ? `, ${user.location.region}` : ""
                    }`}
                  socials={user.social}
                  languages={user.languages}
                />
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center text-center text-[#1B475D] bg-[#F7F2E3] border border-[#D3DC7C] py-12 rounded-lg shadow-inner mb-12">
          <FaLightbulb className="text-[#FAD564]" size={40} />
          <h2 className="text-lg font-semibold mt-4">{t.noProfessionalsTitle}</h2>
          <p className="text-sm text-[#1B475D]/80 mt-2 max-w-md px-4">
            {t.noProfessionalsDescription}
          </p>
          <Link
            href={`/${locale}/register`}
            className="mt-6 inline-block bg-[#8EBD9D] hover:bg-[#77A885] text-[#1B475D] font-semibold px-6 py-2 rounded-full transition"
          >
            {t.register}
          </Link>
        </div>
      )}

      <ServiceOfferBanner locale={locale} />
    </div>
  );
}
